import { RequestParams, ResponseCatalog } from 'Models'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AgreementModel, ChangeAgreementRequestParams } from 'Pages/admin'
import { Callback } from 'Src/types/utilTypes'

export type AgreementState = {
	agreementList: ResponseCatalog<AgreementModel>
	agreementParams: RequestParams
	description: AgreementModel
	isEditAgreement: boolean
}

export const agreementsInitialState: AgreementState = {
	agreementList: new ResponseCatalog<AgreementModel>(),
	agreementParams: new RequestParams(),
	description: null,
	isEditAgreement: false,
}

export namespace AgreementNS {
	export type getAllAgreement = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type setAllAgreement = PayloadAction<ResponseCatalog<AgreementModel>>
	export type setAgreementRequestParams = PayloadAction<RequestParams>
	export type clearAllAgreement = PayloadAction
	export type getAgreement = PayloadAction<{ id: number }>
	export type getAgreementByKey = PayloadAction<{ parentType: string; key?: string }>
	export type setAgreement = PayloadAction<AgreementModel>
	export type updateAgreement = PayloadAction<{ id: number; data: ChangeAgreementRequestParams }>
	export type updateAgreementVersion = PayloadAction<{ data: ChangeAgreementRequestParams }>
	export type clearAgreement = PayloadAction
	export type setIsEditAgreement = PayloadAction<boolean>
}

export const AgreementsSlice = createSlice({
	name: 'agreements',
	initialState: agreementsInitialState,
	reducers: {
		getAll: (state, action: AgreementNS.getAllAgreement) => {},
		setAll: (state, action: AgreementNS.setAllAgreement) => {
			state.agreementList = action.payload
		},
		setRequestParams: (state, action: AgreementNS.setAgreementRequestParams) => {
			state.agreementParams = action.payload
		},
		clearAll: (state, action: AgreementNS.clearAllAgreement) => {
			state.agreementList = new ResponseCatalog<AgreementModel>()
			state.agreementParams = new RequestParams()
		},
		getOne: (state, action: AgreementNS.getAgreement) => {},
		getOneByKey: (state, action: AgreementNS.getAgreementByKey) => {},
		setOne: (state, action: AgreementNS.setAgreement) => {
			state.description = action.payload
		},
		updateOne: (state, action: AgreementNS.updateAgreement) => {},
		updateOneVersion: (state, action: AgreementNS.updateAgreementVersion) => {},
		clearOne: (state, action: AgreementNS.clearAgreement) => {
			state.description = null
		},
		setIsEdit: (state, action: AgreementNS.setIsEditAgreement) => {
			state.isEditAgreement = action.payload
		},
	},
})
